// src/client/components/profile-manager/detail-view/BasicInformationSection.tsx

import InlineEditField from './InlineEditField';
import type { ProfileWithRelations } from '@shared/types';

interface BasicInformationSectionProps {
  profile: ProfileWithRelations;
  onUpdate: (updates: Partial<ProfileWithRelations>) => Promise<void>;
}

export default function BasicInformationSection({
  profile,
  onUpdate,
}: BasicInformationSectionProps) {
  return (
    <div className="border rounded-lg p-4 bg-white">
      <h3 className="text-lg font-semibold mb-4">Basic Information</h3>
      
      <InlineEditField
        label="Name"
        value={profile.name}
        onSave={(value) => onUpdate({ name: value as string })}
        type="text"
      />
      
      <InlineEditField
        label="First Name"
        value={profile.firstName}
        onSave={(value) => onUpdate({ firstName: value as string })}
        type="text"
      />
      
      <InlineEditField
        label="Last Name"
        value={profile.lastName}
        onSave={(value) => onUpdate({ lastName: value as string })}
        type="text"
      />
      
      <InlineEditField
        label="Email"
        value={profile.email}
        onSave={(value) => onUpdate({ email: value as string })}
        type="email"
      />

      <InlineEditField
              label="Gender"
              value={profile.gender}
              onSave={(value) => onUpdate({ gender: value as string })}
              type="text"
      />      
      
      <InlineEditField
        label="Academic Title"
        value={profile.academicTitle}
        onSave={(value) => onUpdate({ academicTitle: value as string })}
        type="text"
      />

      <InlineEditField
        label="Title"
        value={profile.title}
        onSave={(value) => onUpdate({ title: value as string })}
        type="text"
      />
      
      <InlineEditField
        label="Company"
        value={profile.company}
        onSave={(value) => onUpdate({ company: value as string })}
        type="text"
      />
    </div>
  );
}